export const poiMarkerSmall = `
<svg xmlns="http://www.w3.org/2000/svg" width="44" height="51" viewBox="0 0 44 51">
    <g fill="none" fill-rule="evenodd">
        <g>
            <g>
                <g transform="translate(-312 -95) translate(312 95) translate(6 6)">
                    <ellipse cx="16" cy="37.5" fill="#000" fill-opacity=".5" rx="3" ry="1.5"/>
                    <path class="pin-border" fill="#FFDC00" d="M16 38c.615 0 1.23-4.903 6.161-7.353C27.939 28.243 32 22.562 32 15.935 32 7.135 24.837 0 16 0S0 7.135 0 15.935c0 6.644 4.081 12.337 9.883 14.73C14.77 33.097 15.385 38 16 38z"/>
                    <path class="pin-background" fill="#FFF" d="M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14S23.732 2 16 2z"/>
                </g>
            </g>
        </g>
    </g>
</svg>
` 

export const poiMarkerSmallText = `
<svg xmlns="http://www.w3.org/2000/svg" width="44" height="64" viewBox="0 0 44 64">
    <g fill="none" fill-rule="evenodd">
        <g>
            <g>
                <g transform="translate(-354 -82) translate(354 82) translate(6 6)">
                    <ellipse cx="16" cy="50.5" fill="#000" fill-opacity=".5" rx="3" ry="1.5"/>
                    <path class="pin-border" fill="#0071BB" d="M26 0c3.314 0 6 2.686 6 6v22h-.027c.018.31.027.622.027.935 0 6.627-4.06 12.308-9.839 14.712C17.231 46.097 16.615 51 16 51c-.615 0-1.23-4.903-6.117-7.335C4.081 41.272 0 35.579 0 28.935c0-.313.01-.625.027-.935H0V6c0-3.314 2.686-6 6-6h20z"/>
                    <path class="pin-background" fill="#FFF" d="M16 15C8.268 15 2 21.268 2 29s6.268 14 14 14 14-6.268 14-14-6.268-14-14-14z"/>
                </g>
            </g>
        </g>
    </g>
</svg>

` 

export const poiMarkerBig = `
<svg xmlns="http://www.w3.org/2000/svg" width="72" height="88" viewBox="0 0 72 88">
    <g fill="none" fill-rule="evenodd">
        <g>
            <g>
            <g transform="translate(-48 -58) translate(48 58) translate(6 6)">
            <path class="pin-border" fill="#FFDC00" d="M30,69.1c1.9,0,3.4,1.5,3.4,3.4c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4S28.1,69.1,30,69.1z M30,0.1 c16.5,0,29.9,13.6,29.9,30.4c0,12.6-7.6,23.5-18.4,28c-9.2,4.7-10.4,9-11.5,9s-2.3-4.3-11.4-8.9C7.7,53.9,0.1,43.1,0.1,30.4 C0.1,13.7,13.5,0.1,30,0.1z"/>
            <path class="pin-background" fill="#FFF" fill-rule="nonzero" d="M30,3.1C15.2,3.1,3.1,15.3,3.1,30.4s12,27.3,26.9,27.3s26.9-12.2,26.9-27.3S44.8,3.1,30,3.1z"/>
        </g>
            </g>
        </g>
    </g>
</svg>
` 

export const poiMarkerBigText = `
<svg xmlns="http://www.w3.org/2000/svg" width="71" height="109" viewBox="0 0 71 109">
    <g fill="none" fill-rule="evenodd">
        <g>
            <g>
                <g transform="translate(-103 -37) translate(103 37) translate(6 6)">
                    <path class="pin-border" fill="#0071BB" d="M29.5 90.263c1.862 0 3.371 1.508 3.371 3.369 0 1.86-1.509 3.368-3.371 3.368s-3.371-1.508-3.371-3.368c0-1.86 1.509-3.369 3.371-3.369zM50 0c4.97 0 9 4.03 9 9v44h-.016c-.381 12.059-7.752 22.32-18.125 26.728-9.09 4.615-10.224 8.85-11.359 8.85-1.135 0-2.27-4.235-11.278-8.816C7.806 75.374.398 65.09.016 53H0V9c0-4.97 4.03-9 9-9h41z"/>
                    <path class="pin-background" fill="#FFF" fill-rule="nonzero" d="M29.5 25C14.87 25 3 37.082 3 52s11.87 27 26.5 27S56 66.918 56 52 44.13 25 29.5 25z"/>
                </g>
            </g>
        </g>
    </g>
</svg>

` 

export const singleLocationInnerPin = `
<svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <g>
                    <g>
                        <path d="M17.604 3.41c4.704 0 8.517 3.86 8.517 8.622 0 4.224-3.001 7.738-6.963 8.477l-.942 11.9c-.025.316-.289.56-.606.56-.316 0-.58-.245-.604-.56l-.92-11.893c-3.98-.724-7-4.247-7-8.484 0-4.762 3.813-8.621 8.518-8.621z" transform="translate(-64 -38) translate(47 22) translate(6 6) translate(11.329 10.337)"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
` 
